// Libraries
import I18n from 'i18next'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { message, Modal } from 'antd'
import { get, includes, defaultTo } from 'lodash'

// Ressources
import { actions as siteActions } from 'Resources/SiteResource'

// Common components
import { TableLayout, ManageModal } from 'Components'

// Styles
import './SitesScreen.less'

const { confirm } = Modal

class SitesScreen extends Component {
  static propTypes = {
    // Actions d'API
    actions: PropTypes.object,

    // DonnÃ©es de la vue
    site: PropTypes.object,
    sites: PropTypes.array,

    // TÃ©moin d'activitÃ© API
    isGathering: PropTypes.bool,
    isUpdating: PropTypes.bool,
    isCreating: PropTypes.bool,

    // Structure du tableLayout
    buttons: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    table: PropTypes.object,

    // Structure de la manageModal
    manageModal: PropTypes.object,

    // Navigation interne
    navigation: PropTypes.shape({
      navigate: PropTypes.func.isRequired,
      getParam: PropTypes.func.isRequired
    })
  }

  static defaultProps = {
    // Actions d'API
    actions: {},

    // DonnÃ©es de la vue
    site: {},
    sites: [],

    // TÃ©moin d'activitÃ© API
    isGathering: false,
    isUpdating: false,
    isCreating: false,

    // Structure du tableLayout
    table: {
      // Actions groupÃ©es
      actions: {
        global: {
          create: {
            label: 'common.create',
            icon: 'plus'
          }
        },
        selection: {
          // archive: {
          //   buttonType: 'danger'
          // },
          // update: {
          //   buttonType: 'primary'
          // },
          delete: {
            buttonType: 'danger'
          }
        }
      },

      // Gestion de l'internationalisation
      locale: {
        emptyText: 'pages.sites.table.empty'
      },

      // Gestion de la pagination
      pagination: {
        position: 'both',
        showSizeChanger: true,
        pageSizeOptions: ['10', '25', '50', '100']
      },

      // Identifiant unique de chaque ligne du tableau
      rowKey: 'id',

      // Colonnes du tableau
      columns: {
        name: {
          title: 'pages.sites.table.columns.name.title',
          dataIndex: 'name',
          key: 'name',
          sorter: (a, b) =>
            defaultTo(get(a, 'name'), '').localeCompare(
              defaultTo(get(b, 'name'), '')
            ),
          defaultSortOrder: 'ascend'
        },
        location: {
          title: 'pages.sites.table.columns.location.title',
          dataIndex: 'location',
          key: 'location',
          render: location => location,
          sorter: (a, b) =>
            defaultTo(get(a, 'location'), '').localeCompare(
              defaultTo(get(b, 'location'), '')
            )
        }
      }
    },

    // Structure de la manageModal
    manageModal: {
      title: {
        update: 'pages.sites.modal.update.single.title',
        create: 'pages.sites.modal.create.single.title'
      },
      okText: {
        update: 'pages.sites.modal.update.single.okText',
        create: 'pages.sites.modal.create.single.okText'
      },
      actions: {
        delete: {
          buttonType: 'danger'
        }
      },
      rows: {
        name: {
          title: 'pages.sites.modal.rows.name.title',
          dataIndex: 'name',
          key: 'name',
          formField: {
            label: 'pages.sites.modal.rows.name.title',
            required: 'pages.sites.modal.rows.name.requiredMessage',
            placeholder: 'pages.sites.modal.rows.name.placeholder'
          }
        },
        location: {
          title: 'pages.sites.modal.rows.location.title',
          dataIndex: 'location',
          key: 'location',
          formField: {
            type: 'location',
            label: 'pages.sites.modal.rows.location.title',
            required: 'pages.sites.modal.rows.location.requiredMessage',
            placeholder: 'pages.sites.modal.rows.location.placeholder'
          }
        }
      }
    }
  }

  constructor(props) {
    super(props)

    this.state = {
      openedModal: null
    }
  }

  componentDidMount = () => {
    // RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
    this.fetchSitesData()
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
   */
  fetchSitesData = () => {
    this.props.actions.fetchSites().catch(() => {
      message.error(I18n.t('api.errors.site.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es dÃ©taillÃ©es d'un Ã©lÃ©ment de la vue
   */
  getSiteData = site =>
    new Promise((resolve, reject) => {
      this.props.actions
        .getSite(site)
        .then(response => {
          // DÃ©tails rÃ©cupÃ©rÃ©s
          resolve(get(response, 'body'), response)
        })
        .catch(error => {
          // Erreur lors du refresh
          reject(error)
          message.error(I18n.t('api.errors.site.get'))
        })
    })

  /**
   * Actions groupÃ©e:
   * Archivage de plusieurs lignes du tableau
   */
  archiveSites = (sites, clearTableSelections) => {
    this.props.actions
      .archiveSites(sites)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.site.bulk.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.site.bulk.archive'))
      })
  }

  /**
   * Archivage d'une ligne du tableau
   */
  archiveSite = site => {
    this.props.actions
      .archiveSite(site)
      .then(() => {
        this.handleCloseModal()
        message.success(I18n.t('api.success.site.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.site.archive'))
      })
  }

  /**
   * Actions groupÃ©e:
   * Suppression de plusieurs lignes du tableau
   */
  deleteSites = (sites, clearTableSelections) => {
    this.props.actions
      .deleteSites(sites)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.site.bulk.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.site.bulk.delete'))
      })
  }

  /**
   * Suppression d'une ligne du tableau
   */
  deleteSite = site => {
    this.props.actions
      .deleteSite(site)
      .then(() => {
        this.handleCloseModal()
        message.success(I18n.t('api.success.site.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.site.delete'))
      })
  }

  /**
   * Mise Ã  jour d'un site
   */
  updateSite = (updatedSite, originalSite) =>
    new Promise((resolve, reject) => {
      this.props.actions
        .updateSite({ id: get(originalSite, 'id'), ...updatedSite })
        .then(response => {
          this.handleCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.site.update'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.site.update'))
        })
    })

  /**
   * CrÃ©ation d'un site
   */
  createSite = createdSite =>
    new Promise((resolve, reject) => {
      this.props.actions
        .createSite(createdSite)
        .then(response => {
          this.handleCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.site.create'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.site.create'))
        })
    })

  /**
   * Actions groupÃ©e:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askArchiveSites = (...params) => {
    confirm({
      title: I18n.t('pages.sites.modal.archive.multiple.title'),
      content: I18n.t('pages.sites.modal.archive.multiple.content'),
      okText: I18n.t('pages.sites.modal.archive.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.sites.modal.archive.multiple.cancelText'),
      onOk: () => {
        this.archiveSites(...params)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askArchiveSite = () => {
    const site = get(this.props, 'site')

    confirm({
      title: I18n.t('pages.sites.modal.archive.single.title'),
      content: I18n.t('pages.sites.modal.archive.single.content'),
      okText: I18n.t('pages.sites.modal.archive.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.sites.modal.archive.single.cancelText'),
      onOk: () => {
        this.archiveSite(site)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Actions groupÃ©e:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askDeleteSites = (...params) => {
    confirm({
      title: I18n.t('pages.sites.modal.delete.multiple.title'),
      content: I18n.t('pages.sites.modal.delete.multiple.content'),
      okText: I18n.t('pages.sites.modal.delete.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.sites.modal.delete.multiple.cancelText'),
      onOk: () => {
        this.deleteSites(...params)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askDeleteSite = () => {
    const site = get(this.props, 'site')

    confirm({
      title: I18n.t('pages.sites.modal.delete.single.title'),
      content: I18n.t('pages.sites.modal.delete.single.content'),
      okText: I18n.t('pages.sites.modal.delete.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.sites.modal.delete.single.cancelText'),
      onOk: () => {
        this.deleteSite(site)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Ouverture de la modale de modifications
   */
  openModal = (creating = true) => {
    this.setState({ openedModal: creating ? 'createSite' : 'updateSite' })
  }

  /**
   * Fermeture de toutes les modales
   */
  handleCloseModal = () => {
    const { openedModal } = this.state

    if (openedModal === 'updateSite') {
      this.setState({ openedModal: 'transition' }, () => {
        setTimeout(this.setState({ openedModal: null }), 200)
      })
    } else {
      this.setState({ openedModal: null })
    }
  }

  /**
   * Callback:
   * CrÃ©ation d'une ligne de tableau rÃ©ussie
   */
  handleSiteCreated = () => {
    this.handleCloseModal()
  }

  /**
   * Clic sur une ligne du tableau
   */
  handleRowClick = site => {
    this.getSiteData(site)
    this.setState({ openedModal: 'updateSite' })
  }

  render() {
    const {
      table,
      isGathering,
      manageModal,
      isUpdating,
      isCreating,
      sites,
      site
    } = this.props
    const { openedModal } = this.state

    // GESTION DES TABLEAUX

    // Ajout des donnÃ©es au tableau
    table.rows = sites

    // Ajout des actions au clic sur un ligne du tableau
    table.onRow = (site, id) => ({
      onClick: () => this.handleRowClick(site, id)
    })

    // Ajout des actions multiples sur le tableau
    // table.actions.selection.archive.onClick = this.askArchiveSites
    table.actions.selection.delete.onClick = this.askDeleteSites
    // table.actions.selection.update.onClick = this.askUpdateSites

    // GESTION DES BOUTONS

    // Ajout des actions des boutons
    table.actions.global.create.onClick = this.openModal

    // GESTION DE LA MODALE DE GESTION

    // Ajout des actions sur la modale
    manageModal.actions.delete.onClick = this.askDeleteSite

    // GESTION DES LOADERS
    const loading = isGathering || isUpdating || isCreating

    return (
      <main className='screen sites'>
        {/* Affichage des donnÃ©es de la page */}
        <TableLayout
          elementName='site'
          elementKind='male'
          elementConsonant
          loading={loading}
          {...table}
        />

        {/* Ouverture de la modale de crÃ©ation / modification */}
        <ManageModal
          loading={loading}
          onCancel={this.handleCloseModal}
          onOk={this.handleSiteCreated}
          onChange={
            openedModal === 'updateSite' ? this.updateSite : this.createSite
          }
          visible={includes(['createSite', 'updateSite'], openedModal)}
          data={
            includes(['transition', 'updateSite'], openedModal) ? site : null
          }
          {...manageModal}
        />
      </main>
    )
  }
}

const mapStateToProps = state => {
  const defaultProps = get(SitesScreen, 'defaultProps', {})

  return {
    site: defaultTo(get(state, 'site.item'), defaultProps.site),
    sites: defaultTo(get(state, 'site.items'), defaultProps.sites),
    isGathering:
      defaultTo(get(state, 'site.isFetching'), defaultProps.isGathering) ||
      defaultTo(get(state, 'site.isFetchingItem'), defaultProps.isGathering),
    isUpdating: defaultTo(
      get(state, 'site.isUpdating'),
      defaultProps.isUpdating
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...siteActions }, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SitesScreen)
